<template>
  <div class="container">
    <div class="query-container">
      <h1>😊喜悦假期天天爆单🎶</h1>
      <div class="textjieshao">多端合一查询系统</div>

      <div class="input-container">
        <textarea v-model="queryText" :maxlength="maxChars" placeholder="请输入查询内容" rows="6" class="query-textarea"></textarea>
        <div class="button-container">
          <button :disabled="isLoading" class="btn-primary" @click="handleQuery">查询</button>
          <button class="btn-clipboard" :disabled="isLoading" @click="pasteAndQuery">剪贴板查询</button>
          <button class="btn-secondary" @click="resetInput">清空</button>
        </div>
      </div>

      <div v-if="isLoading" class="loading">查询中，请稍候...</div>
      <div v-if="errorMessage" class="error">{{ errorMessage }}</div>

      <div v-if="yituError" class="warning-banner">
        <span class="warning-icon">⚠</span>
        <span class="warning-text">{{ yituError }}</span>
      </div>

      <!-- 统计栏 -->
      <div v-if="guestList.length" class="summary-bar">
        <div class="summary-item">
          <span class="num">{{ guestList.length }}</span><span class="txt">位客人</span>
          <template v-if="maleCount"><span class="sep">·</span><span class="num">{{ maleCount }}</span><span class="txt">男</span></template>
          <template v-if="femaleCount"><span class="sep">·</span><span class="num">{{ femaleCount }}</span><span class="txt">女</span></template>
          <template v-if="foreignCount"><span class="sep">·</span><span class="num">{{ foreignCount }}</span><span class="txt">外宾</span></template>
        </div>
        <div v-if="phoneList.length" class="summary-phone" @click="showPhoneModal = true">
          <span class="phone-icon">📱</span>
          <span class="phone-count">{{ phoneList.length }}</span>
          <span class="phone-txt">个手机号</span>
          <span class="phone-arrow">›</span>
        </div>
      </div>

      <!-- 表格1：身份信息 -->
      <div v-if="guestList.length" class="table-container">
        <h2>身份信息</h2>
        <div class="scroll-table">
          <div class="table-wrapper-IDcode">
            <table>
              <thead>
                <tr>
                  <th>序号</th>
                  <th>客人</th>
                  <th>身份证</th>
                  <th>年龄</th>
                  <th>性别</th>
                  <th>生日</th>
                  <th>归属地</th>
                  <th>订单人数</th>
                  <th>总人均</th>
                  <th>手机号</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(g, idx) in guestList" :key="idx" :class="rowBgClass(g)">
                  <td>{{ idx + 1 }}</td>
                  <td>
                    <span v-if="g.remark && g.remark.length" class="remark-link" @click="openRemarkModal(g)">{{ g.fullName || '空' }} ⚠</span>
                    <span v-else>{{ g.fullName || '空' }}</span>
                  </td>
                  <td class="scrollable-cell">{{ g.fullId || '空' }}</td>
                  <td>{{ g.age || '空' }}</td>
                  <td>{{ g.sex || '空' }}</td>
                  <td>{{ g.birth || '空' }}</td>
                  <td class="scrollable-cell">{{ g.license || '空' }}</td>
                  <td>{{ g.num || '-' }}</td>
                  <td>{{ g.zhi || '-' }}</td>
                  <td class="phone-cell">
                    <template v-if="g.tel && g.tel.length">
                      <span v-for="(phone, pi) in g.tel" :key="pi" class="phone-item" @click="openTelModal(phone)">{{ phone }}<span v-if="pi < g.tel.length - 1"> / </span></span>
                    </template>
                    <span v-else>-</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- 表格2：出行信息 -->
      <div v-if="hasTrips" class="table-container">
        <h2>出行信息</h2>
        <div class="scroll-table">
          <div class="table-wrapper-YiTu">
            <table>
              <thead>
                <tr>
                  <th>序号</th>
                  <th>客人</th>
                  <th>证件号码</th>
                  <th>出团</th>
                  <th>旅行线路</th>
                  <th>地区</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(g, idx) in guestList" :key="idx">
                  <tr v-for="(t, ti) in g.trips" :key="idx + '-' + ti">
                    <td>{{ ti === 0 ? idx + 1 : '' }}</td>
                    <td>{{ ti === 0 ? g.fullName : '' }}</td>
                    <td>{{ ti === 0 ? g.fullId : '' }}</td>
                    <td>{{ formatTripDate(t) }}</td>
                    <td>{{ t.PlayName || '空' }}</td>
                    <td>{{ t.PlayArea || '空' }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- 设置按钮 -->
    <div class="settings-button-container" ref="settingsContainer">
      <button @click="handleSettingsClick" class="settings-button">
        <i class="fas fa-cog" :class="{ 'rotating': isAnimating }"></i>
      </button>
      <div v-if="showSettings" class="settings-panel">
        <div class="settings-header">
          <h3>主题设置</h3>
          <button @click="showSettings = false" class="close-button">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="settings-content">
          <div class="theme-section">
            <div class="theme-grid">
              <button v-for="t in themes" :key="t.id"
                :class="['theme-card', { selected: currentTheme === t.id }]"
                @click="switchTheme(t.id)">
                <div :class="['theme-preview', t.id + '-preview']"></div>
                <span>{{ t.label }}</span>
              </button>
            </div>
          </div>
          <div class="actions-section">
            <button class="logout-button" @click="logout">
              <i class="fas fa-sign-out-alt"></i>
              <span>登出</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 手机号查询模态窗 -->
    <div v-if="showTelModal" class="modal-overlay" @click.self="showTelModal = false">
      <div class="tel-modal-box">
        <div class="tel-modal-title">手机号查询</div>
        <div class="tel-modal-num">{{ telModalNumber }}</div>
        <div class="tel-modal-actions">
          <a :href="'https://www.tianyancha.com/nsearch?key=' + telModalNumber" target="_blank" class="tel-btn tyc" @click="showTelModal = false">🔍 天眼查</a>
          <a :href="'https://www.qcc.com/web/search?key=' + telModalNumber" target="_blank" class="tel-btn qcc" @click="showTelModal = false">🔍 企查查</a>
        </div>
      </div>
    </div>

    <!-- 备注模态窗 -->
    <div v-if="showRemarkModal" class="modal-overlay" @click.self="showRemarkModal = false">
      <div class="remark-modal-box">
        <div class="remark-modal-header">
          <div class="remark-modal-title">⚠ {{ remarkModalData.name }} 的备注</div>
          <button class="modal-close" @click="showRemarkModal = false">✕</button>
        </div>
        <div class="remark-modal-body">
          <div v-for="(r, ri) in remarkModalData.remarks" :key="ri" class="remark-row">
            <span class="remark-index">{{ ri + 1 }}</span>
            <span class="remark-text">{{ r }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 手机号列表模态窗 -->
    <div v-if="showPhoneModal" class="modal-overlay" @click.self="showPhoneModal = false">
      <div class="phone-modal-box">
        <div class="phone-modal-header">
          <div class="phone-modal-title">📱 手机号列表</div>
          <div class="phone-modal-count">共 {{ phoneList.length }} 个</div>
          <button class="modal-close" @click="showPhoneModal = false">✕</button>
        </div>
        <div class="phone-modal-body">
          <div v-for="(phone, pi) in phoneList" :key="pi" class="phone-row">
            <span class="phone-num">{{ phone }}</span>
            <div class="phone-row-actions">
              <a :href="'https://www.tianyancha.com/nsearch?key=' + phone" target="_blank" class="phone-link tyc">天眼查</a>
              <a :href="'https://www.qcc.com/web/search?key=' + phone" target="_blank" class="phone-link qcc">企查查</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { inject } from 'vue';
import '../assets/styles/variables.css';
import '../assets/styles/base.css';
import '../assets/styles/light.css';
import '../assets/styles/dark.css';
import '../assets/styles/hailang.css';
import '../assets/styles/jiahao.css';
import '../assets/styles/meili.css';

export default {
  data() {
    return {
      queryText: '',
      isLoading: false,
      errorMessage: '',
      guestList: [],
      phoneList: [],
      yituError: '',
      maxChars: 3000,
      showSettings: false,
      currentTheme: 'light',
      isAnimating: false,
      showTelModal: false,
      telModalNumber: '',
      showRemarkModal: false,
      remarkModalData: { name: '', remarks: [] },
      showPhoneModal: false,
      themes: [
        { id: 'light', label: '浅色主题' },
        { id: 'dark', label: '深色主题' },
        { id: 'jiahao', label: '嘉豪定制' },
        { id: 'hailang', label: '海浪定制' },
        { id: 'meili', label: '美丽定制' }
      ]
    };
  },
  setup() {
    const globalState = inject('globalState');
    const globalConfig = inject('globalConfig');
    return { globalConfig, globalState };
  },
  computed: {
    maleCount() {
      return this.guestList.filter(g => g.sex === '男').length;
    },
    femaleCount() {
      return this.guestList.filter(g => g.sex === '女').length;
    },
    foreignCount() {
      return this.guestList.filter(g => g.sex === '外宾').length;
    },
    hasTrips() {
      return this.guestList.some(g => g.trips && g.trips.length);
    }
  },
  methods: {
    async handleQuery() {
      if (!this.queryText.trim()) {
        this.errorMessage = '请输入查询内容';
        return;
      }
      if (this.queryText.length > this.maxChars) {
        this.errorMessage = `输入内容不能超过 ${this.maxChars} 个字符`;
        return;
      }

      this.isLoading = true;
      this.errorMessage = '';
      this.guestList = [];
      this.phoneList = [];
      this.yituError = '';

      try {
        const { apiUrl } = this.globalConfig;
        const password = localStorage.getItem('password');

        const response = await fetch(`${apiUrl}/HsInquire/array`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ IDMessage: this.queryText, code: password })
        });

        const result = await response.json();

        if (response.status === 200) {
          this.guestList = result.Guests || [];
          this.phoneList = result.Phone || [];
          this.yituError = result.YiTuError || '';
        } else if (result.Hs_mio === 'uppassword') {
          localStorage.removeItem('authenticated');
          localStorage.removeItem('password');
          this.globalState.authenticated = false;
        } else {
          this.errorMessage = result.error || '查询失败';
        }
      } catch (error) {
        console.error('查询出错:', error);
        this.errorMessage = '查询出错，请稍后再试';
      } finally {
        this.isLoading = false;
      }
    },
    resetInput() {
      this.queryText = '';
      this.guestList = [];
      this.phoneList = [];
      this.errorMessage = '';
      this.yituError = '';
    },
    async pasteAndQuery() {
      try {
        const text = await navigator.clipboard.readText();
        if (!text || !text.trim()) {
          this.errorMessage = '请先复制';
          return;
        }
        const idCardRegex = /\d{17}[\dXx]|\d{15}/;
        if (!idCardRegex.test(text)) {
          this.errorMessage = '没有发现有复制的查询内容';
          return;
        }
        this.queryText = text.trim();
        this.handleQuery();
      } catch {
        this.errorMessage = '无法读取剪切板，请手动粘贴';
      }
    },
    formatTripDate(t) {
      if (!t.PlayDate) return '空';
      if (t.PlayNum > 1) {
        const start = new Date(t.PlayDate);
        const end = new Date(start);
        end.setDate(end.getDate() + t.PlayNum - 1);
        const endStr = end.toISOString().slice(0, 10);
        return `${t.PlayDate} - ${endStr}`;
      }
      return t.PlayDate;
    },
    openTelModal(tel) {
      this.telModalNumber = tel;
      this.showTelModal = true;
    },
    openRemarkModal(g) {
      this.remarkModalData = { name: g.fullName, remarks: g.remark || [] };
      this.showRemarkModal = true;
    },
    rowBgClass(g) {
      const colorMap = {
        'red': 'row-red',
        'green': 'row-green',
        'yellow': 'row-yellow',
        'light-yellow': 'row-light-yellow'
      };
      return colorMap[g.licenseColor] || '';
    },
    handleSettingsClick() {
      this.isAnimating = true;
      this.showSettings = !this.showSettings;
      setTimeout(() => { this.isAnimating = false; }, 500);
    },
    switchTheme(theme) {
      this.currentTheme = theme;
      document.documentElement.setAttribute('data-theme', theme);
      localStorage.setItem('selectedTheme', theme);

      const colors = {
        light: '#ffffff',
        dark: '#333333',
        jiahao: '#f7e4e2',
        hailang: '#d0e6f9',
        meili: '#E0F7E8'
      };
      let meta = document.querySelector('meta[name="theme-color"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'theme-color');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', colors[theme] || '#ffffff');
    },
    loadTheme() {
      const saved = localStorage.getItem('selectedTheme');
      this.switchTheme(saved || this.currentTheme);
    },
    handleClickOutside(event) {
      if (this.$refs.settingsContainer && !this.$refs.settingsContainer.contains(event.target)) {
        this.showSettings = false;
      }
    },
    logout() {
      localStorage.removeItem('authenticated');
      localStorage.removeItem('password');
      this.globalState.authenticated = false;
      this.showSettings = false;
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    this.loadTheme();
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>

<style scoped>
/* ============ 整行背景色 ============ */
.row-red td { background-color: red; }
.row-green td { background-color: rgb(163, 255, 65); }
.row-yellow td { background-color: rgb(255, 192, 0); }
.row-light-yellow td { background-color: rgb(255, 230, 153); }

/* ============ 表格内手机号列 ============ */
.phone-cell {
  white-space: nowrap;
}
.phone-item {
  color: #007aff;
  cursor: pointer;
  font-family: "SF Mono", "Consolas", "Menlo", monospace;
}
.phone-item:hover {
  text-decoration: underline;
  color: #005ecb;
}

/* ============ 查询框 ============ */
.query-textarea {
  width: 360px;
  max-height: 150px;
  padding: 10px;
  resize: none;
  border: 1px solid #ccc;
  border-radius: 8px;
  background: #f7f7f7;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-size: 14px;
  line-height: 1.5;
  font-family: inherit;
}
.query-textarea:focus {
  outline: none;
  border-color: #000;
  border-width: 2px;
}
.btn-primary {
  padding: 10px 20px;
  cursor: pointer;
  background: #007aff;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 14px;
}
.btn-primary:hover { background: #005ecb; }
.btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }
.btn-secondary {
  padding: 10px 20px;
  cursor: pointer;
  background: #868e96;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 14px;
}
.btn-secondary:hover { background: #6c757d; }
.btn-clipboard {
  padding: 10px 16px;
  cursor: pointer;
  background: #5856d6;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 14px;
}
.btn-clipboard:hover { background: #4240b0; }
.btn-clipboard:disabled { opacity: 0.6; cursor: not-allowed; }

/* ============ 备注链接 ============ */
.remark-link {
  color: #d48806;
  cursor: pointer;
  font-weight: 500;
}
.remark-link:hover {
  color: #ad6800;
  text-decoration: underline;
}

/* ============ 备注模态窗 ============ */
.remark-modal-box {
  background: #fff;
  border-radius: 12px;
  width: 400px;
  max-width: 92vw;
  max-height: 70vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}
.remark-modal-header {
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}
.remark-modal-title {
  font-size: 16px;
  font-weight: 700;
}
.remark-modal-body {
  overflow-y: auto;
  flex: 1;
  padding: 12px 20px 20px;
}
.remark-row {
  display: flex;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #f5f5f5;
  align-items: flex-start;
}
.remark-row:last-child {
  border-bottom: none;
}
.remark-index {
  color: #999;
  font-size: 12px;
  min-width: 20px;
  text-align: right;
  flex-shrink: 0;
  padding-top: 2px;
}
.remark-text {
  color: #333;
  font-size: 14px;
  line-height: 1.5;
  word-break: break-all;
}

/* ============ 警告横幅 ============ */
.warning-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  margin-bottom: 14px;
  background: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 6px;
  color: #d48806;
  font-size: 13px;
}
.warning-icon { font-size: 16px; }

/* ============ 摘要 ============ */
.summary-bar {
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 14px;
}
.summary-item {
  border-radius: 8px;
  padding: 6px 14px;
  display: flex;
  align-items: baseline;
  gap: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.summary-item .num { font-size: 20px; font-weight: 700; color: #007aff; }
.summary-item .txt { font-size: 12px; color: #999; }
.summary-item .sep { color: #ddd; margin: 0 2px; }

/* ============ 手机号标签 ============ */
.summary-phone {
  display: flex;
  align-items: center;
  gap: 4px;
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
  border: 1px solid #a5d6a7;
  border-radius: 8px;
  padding: 6px 14px;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.summary-phone:hover {
  background: linear-gradient(135deg, #c8e6c9 0%, #a5d6a7 100%);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  transform: translateY(-1px);
}
.summary-phone:active { transform: translateY(0); }
.summary-phone .phone-icon { font-size: 16px; }
.summary-phone .phone-count { font-size: 20px; font-weight: 700; color: #2e7d32; }
.summary-phone .phone-txt { font-size: 12px; color: #558b2f; }
.summary-phone .phone-arrow { font-size: 18px; color: #81c784; margin-left: 2px; font-weight: 700; }

/* ============ 表格滚动条 ============ */
.scrollable-cell {
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}
.scrollable-cell::-webkit-scrollbar {
  height: 6px;
}
.scrollable-cell::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}
.scrollable-cell::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}
.scrollable-cell::-webkit-scrollbar-thumb:hover {
  background: #555;
}

table td {
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}
table td::-webkit-scrollbar {
  height: 6px;
}
table td::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}
table td::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}
table td::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* ============ 设置按钮 ============ */
.settings-button-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
}
.settings-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background: #f8f9fa;
  color: #495057;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 40px;
  height: 40px;
}
.settings-button i { font-size: 16px; }

.settings-panel {
  position: absolute;
  top: 50px;
  right: 0;
  width: 500px;
  max-width: 90vw;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border: 1px solid #e9ecef;
  overflow: hidden;
}

.settings-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}
.settings-header h3 { margin: 0; font-size: 16px; font-weight: 500; color: #495057; }
.close-button {
  padding: 6px;
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  color: #6c757d;
}
.close-button:hover { background: #e9ecef; color: #495057; }
.settings-content { padding: 20px; }
.theme-section { margin-bottom: 20px; }
.theme-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(90px, 1fr)); gap: 12px; }
.theme-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 12px 8px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  cursor: pointer;
  font-size: 11px;
  color: #495057;
}
.theme-card:hover { background: #e9ecef; border-color: #adb5bd; }
.theme-card.selected { border-color: #007bff; background: #e7f3ff; }
.theme-preview { width: 32px; height: 24px; border-radius: 4px; border: 1px solid #dee2e6; }
.light-preview { background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%); }
.dark-preview { background: linear-gradient(135deg, #343a40 0%, #212529 100%); }
.jiahao-preview { background: linear-gradient(135deg, #f7e4e2 0%, #fdeef2 100%); }
.hailang-preview { background: linear-gradient(135deg, #d0e6f9 0%, #e6f3ff 100%); }
.meili-preview { background: linear-gradient(135deg, #E0F7E8 0%, #f0fff4 100%); }
.actions-section { padding-top: 16px; border-top: 1px solid #e9ecef; }
.logout-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 10px 16px;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
}
.logout-button:hover { background: #c82333; }
.logout-button i { font-size: 13px; }

/* ============ 模态窗 ============ */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 手机号查询模态窗 */
.tel-modal-box {
  background: #fff;
  border-radius: 12px;
  width: 320px;
  padding: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}
.tel-modal-title { font-size: 15px; font-weight: 700; margin-bottom: 4px; }
.tel-modal-num { font-size: 13px; color: #999; margin-bottom: 16px; }
.tel-modal-actions { display: flex; gap: 10px; }
.tel-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px;
  border-radius: 8px;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}
.tel-btn.tyc { background: #f0f7ff; color: #007aff; border: 1px solid #d0e3ff; }
.tel-btn.qcc { background: #f6ffed; color: #389e0d; border: 1px solid #b7eb8f; }

/* 手机号列表模态窗 */
.phone-modal-box {
  background: #fff;
  border-radius: 12px;
  width: 380px;
  max-width: 92vw;
  max-height: 70vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}
.phone-modal-header {
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.phone-modal-title { font-size: 16px; font-weight: 700; }
.phone-modal-count { font-size: 12px; color: #999; margin-left: auto; }
.modal-close {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #999;
  padding: 4px 8px;
}
.phone-modal-body {
  overflow-y: auto;
  flex: 1;
  padding: 8px 16px 16px;
}
.phone-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 4px;
  border-bottom: 1px solid #f5f5f5;
}
.phone-row:last-child { border-bottom: none; }
.phone-num {
  font-family: "SF Mono", "Consolas", "Menlo", monospace;
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  letter-spacing: 0.5px;
}
.phone-row-actions {
  display: flex;
  gap: 6px;
}
.phone-link {
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 5px;
  text-decoration: none;
  font-weight: 500;
}
.phone-link.tyc { background: #f0f7ff; color: #007aff; border: 1px solid #d0e3ff; }
.phone-link.tyc:hover { background: #d0e3ff; }
.phone-link.qcc { background: #f6ffed; color: #389e0d; border: 1px solid #b7eb8f; }
.phone-link.qcc:hover { background: #d9f7be; }

/* ============ 响应式 ============ */
@media (max-width: 768px) {
  .settings-button-container {
    top: 10px;
    right: 10px;
  }
  .settings-button {
    padding: 6px;
    width: 28px;
    height: 28px;
    background: transparent;
    border: none;
    box-shadow: none;
    color: #6c757d;
  }
  .settings-button i {
    font-size: 12px;
  }
  .settings-panel {
    width: 95vw;
    right: -10px;
    top: 38px;
  }
  .theme-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }
  .theme-card {
    padding: 10px 6px;
    font-size: 10px;
  }
  .theme-preview {
    width: 28px;
    height: 20px;
  }
  .settings-header {
    padding: 14px 16px;
  }
  .settings-header h3 {
    font-size: 15px;
  }
  .settings-content {
    padding: 16px;
  }
  .modal-box { width: 96vw; max-height: 80vh; }
  .phone-modal-box { width: 96vw; max-height: 70vh; }
  .phone-modal-header { padding: 12px 16px; }
  .phone-modal-body { padding: 6px 12px 12px; }
}

@media (max-width: 480px) {
  .settings-button-container {
    top: 8px;
    right: 8px;
  }
  .settings-button {
    padding: 5px;
    width: 24px;
    height: 24px;
    background: transparent;
    border: none;
    box-shadow: none;
    color: #868e96;
  }
  .settings-button:hover {
    background: rgba(233, 236, 239, 0.2);
    border: none;
    box-shadow: none;
  }
  .settings-button i {
    font-size: 10px;
  }
  .settings-panel {
    width: 98vw;
    right: -15px;
    top: 32px;
  }
  .theme-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }
  .theme-card {
    padding: 8px 4px;
    font-size: 9px;
  }
  .theme-preview {
    width: 24px;
    height: 18px;
  }
}
</style>
